// Imports
import { Component, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Constant } from '../../blog/constant';
import { DashboardService } from '../dashboard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Component Decorator
@Component({
  selector: 'what-is-open-end-fund',
  templateUrl: './what-is-open-end-fund.component.html',
  styleUrls: ['./what-is-open-end-fund.component.scss']
})

// Component Class
export class WhatIsOpenEndFundComponent implements OnInit {
  public Constant = Constant;
  parnters: any[] = [];
  constructor(
      public sanitizer:DomSanitizer,
      private dashboardService: DashboardService,
      private ngbModal: NgbModal
  ) {

  }
  ngOnInit() {
    this.getListPartner();
  }
  getListPartner() {
    this.dashboardService.getPartnerList().subscribe((res: any) => {
      const parnters = res.data.issuer || [];
      this.parnters = parnters.filter((item: any) => item.isTopPartner)
      .slice(0, 4)
      .map((item: any) => {
        return {
          logoUrl: item.logoUrl,
          link: '/doi-tac/' + item.path,
          title: item.title,
        }
      });
    });
  }
  
  closeModalAndRedirect() {
    this.dismiss();
    window.open('https://www.facebook.com/groups/fmarketinvestors/', '_blank');
    window.location.reload();
  }

  dismiss() {
    this.ngbModal.dismissAll();
  }
}